module.exports = __webpack_public_path__ + "static/media/GAVPLA.5637ccf5.png";